import { Typography } from "antd";
import { formatPercentage } from "../../utils/calculations";
import { green, red } from "@ant-design/colors";
import StatisticCard from "../StatisticCard";

interface SalesOverviewProps {
  totalSales?: number;
  totalExpenses?: number;
}

const FinancialOverview = ({
  totalSales = 0,
  totalExpenses = 0,
}: SalesOverviewProps) => {
  const profit = totalSales - totalExpenses;
  const profitMargin = totalSales === 0 ? 0 : (profit / totalSales) * 100;

  return (
    <>
      <div style={{ gridColumn: "1 / -1" }}>
        <Typography.Title level={5} style={{ fontWeight: 500 }}>
          Financial Overview
        </Typography.Title>
      </div>

      <StatisticCard
        type="total"
        title="Net Profit"
        value={profit}
        percentage={formatPercentage(profitMargin)}
        percentageColor={profit > 0 ? green[5] : red[5]}
      />
    </>
  );
};

export default FinancialOverview;
